import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
export default createStore({
  state: {
    access_token: null,
    doctor_id:null,
    doctor_name:null,
  },
  getters: {
  },
  mutations: {
    getusermsg(state, val) {
      state.doctor_id = val.doctor_id
      state.doctor_name = val.doctor_name
      state.access_token = val.access_token
    },
    getuserdata(state, val) {
      state.userdata = val.user
      // console.log('usermsg', state.userdata);
    },
    clear(state) {
      state.doctor_id = null
      state.doctor_name = null
      state.access_token = null
      // state.userdata = {}
    },
  },
  actions: {

  },
  modules: {
  },
  plugins: [
    createPersistedState()
  ]
})
